import { render, staticRenderFns } from "./EventCategoryTabBar.vue?vue&type=template&id=22b3505f&scoped=true&"
import script from "./EventCategoryTabBar.vue?vue&type=script&lang=js&"
export * from "./EventCategoryTabBar.vue?vue&type=script&lang=js&"
import style0 from "./EventCategoryTabBar.vue?vue&type=style&index=0&id=22b3505f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3505f",
  null
  
)

export default component.exports